var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderFade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6.857a2 2 0 00-2-2h-5.107a2 2 0 01-1.888-1.34l-.062-.178A2 2 0 007.055 2H4a2 2 0 00-2 2v11a2 2 0 002 2h12a2 2 0 002-2V6.857z",
    fill: "#15154A",
    fillOpacity: 0.06
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOCA2Ljg1Njc2QzE4IDUuNzUyMTkgMTcuMTA0NiA0Ljg1Njc2IDE2IDQuODU2NzZIMTAuODkyOUMxMC4wNDMgNC44NTY3NiA5LjI4NiA0LjMxOTY4IDkuMDA1MjEgMy41MTc1NEw4Ljk0Mjc5IDMuMzM5MjJDOC42NjIwMSAyLjUzNzA5IDcuOTA0OTYgMiA3LjA1NTEgMkg0QzIuODk1NDMgMiAyIDIuODk1NDMgMiA0VjE1QzIgMTYuMTA0NiAyLjg5NTQzIDE3IDQgMTdIMTZDMTcuMTA0NiAxNyAxOCAxNi4xMDQ2IDE4IDE1VjYuODU2NzZaIiBmaWxsPSIjMTUxNTRBIiBmaWxsLW9wYWNpdHk9IjAuMDYiLz4KPC9zdmc+Cg==";
export { SvgFolderFade as ReactComponent };